import { Text } from '@mantine/core';
import { t } from 'i18next';
import { Z_INDEX_VALUES } from 'utils/general';
import { RuleItem, RuleStatus, RuleStatuses } from 'models/rules';
import { OpenConfirmModal } from 'hooks/useGeneralDrawer';

const defaultConfirmModal = {
  zIndex: Z_INDEX_VALUES.modal,
  centered: true,
  confirmProps: { color: 'red' },
  cancelProps: { variant: 'outline' },
};

export const createDiscardPrescriptionModal = (): OpenConfirmModal => ({
  ...defaultConfirmModal,
  title: t('add_prescript_modal_discard_title'),
  children: <Text size={'sm'}>{t('add_prescript_modal_discard_text')}</Text>,
  labels: { confirm: t('confirm_label'), cancel: t('cancel_label') },
});

export const createConfirmDeleteLogModal = (handleDeleteLog: () => void): OpenConfirmModal => ({
  ...defaultConfirmModal,
  title: t('add_log_delete_title'),
  children: <Text size={'sm'}>{t('add_log_delete_text')}</Text>,
  labels: { confirm: t('confirm_label'), cancel: t('cancel_label') },
  onConfirm: handleDeleteLog,
});

export const createConfirmDeleteRuleModal = (
  handleDeleteRule: (item: RuleItem) => void,
  item: RuleItem,
): OpenConfirmModal => ({
  ...defaultConfirmModal,
  title: t('delete_rule_title'),
  children: <Text size={'sm'}>{t('delete_rule_text')}</Text>,
  labels: { confirm: t('confirm_label'), cancel: t('cancel_label') },
  onConfirm: () => handleDeleteRule(item),
});

export const createConfirmApproveRuleModal = (handleApproveRule: () => void): OpenConfirmModal => ({
  ...defaultConfirmModal,
  title: t('approve_rule_title'),
  children: <Text size={'sm'}>{t('approve_rule_text')}</Text>,
  labels: { confirm: t('approve_label'), cancel: t('cancel_label') },
  confirmProps: { color: 'turquoise' },
  onConfirm: handleApproveRule,
});

export const createConfirmResetRuleModal = (handleResetRule: () => void, status: RuleStatus): OpenConfirmModal => ({
  ...defaultConfirmModal,
  title: t('edit_rule_title'),
  children: (
    <Text size={'sm'}>{status === RuleStatuses.enabled ? t('edit_rule_enabled') : t('edit_rule_reviewed')}</Text>
  ),
  labels: { confirm: t('edit_label'), cancel: t('cancel_label') },
  confirmProps: { color: 'turquoise' },
  onConfirm: handleResetRule,
});
